import React, { useState } from 'react';
import { Box } from '@mui/material';
import VideoCatalog from '../components/VideoCatalog/VideoCatalog';

const Home = () => {
  const [videos] = useState([
        {
      url: '/higher_res_o_kultek.mp4',
      title: 'KÜLTEK "THE UNEXPECTED"',
      slug: 'KULTEK',
      desc: 'MERCI ADVERTISING',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Merci Advertising'
    },
     {
      url: '/higher_res_o_bagovit.mp4',
      title: 'BAGOVIT "EMPEZÁ POR LO ESENCIAL"',
      slug: 'BAGOVIT',
      desc: 'BB AGENCIA',
      director: 'DIR.: DAMIÁN GARÓFALO',
      agencia: 'BB Agencia'
    },
    {
      url: '/higher_res_o_intoxicacion.mp4',
      title: 'UNIVERSAL ASSISTANCE "TE CUESTA $0"',
      slug: 'UA-TECUESTA0',
      desc: 'MERCI ADVERTISING',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Merci Advertising'
    },
    {
      url: '/higher_res_o_vid6.mp4',
      title: 'ATMA & "SECTA"',
      slug: 'ATMA',
      desc:'ANITA & VEGA',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Agencia 1'
    },
    {
      url: '/higher_res_o_vid8.mp4',
      title: 'HELLMANN’S "HISTORIAS DE HELADERA"',
      slug: 'HELLMANNS',
      desc: 'OGILVY',
      director: 'DIR.: GLUTEN MORGEN & TOMÁS DE LAS HERAS',
      agencia: 'Agencia 1'
    },
   
  ]);

  // useEffect(() => {
  //   const loadDirectorVideos = async () => {
  //     try {
  //       // Load each director's info directly (since we know which ones we have)
  //       const directorSlugs = ['rada', 'leanmancini'];
  //       const directorVideos = [];
        
  //       for (const directorSlug of directorSlugs) {
  //         const response = await fetch(`/directores/${directorSlug}/info.json`);
  //         const directorData = await response.json();
          
  //         const currentDirectorVideos = directorData.videos.map(video => ({
  //           url: `/directores/${directorSlug}/${video.filename}`,
  //           title: video.name
  //         }));

  //         directorVideos.push(...currentDirectorVideos);
  //       }

  //       // Combine with existing hardcoded videos
  //       setVideos(prev => [...prev, ...directorVideos]);

  //     } catch (error) {
  //       console.error('Error loading director videos:', error);
  //     }
  //   };

  //   loadDirectorVideos();
  // }, []);

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >

      <VideoCatalog videos={videos} />
      {/* <Typography variant="h5" sx={{ color: 'white',
         textAlign: 'center', 
         mt: 1,
         fontWeight: 300,
         fontSize: isMobile ? '1rem' : '1.2rem',
         textAlign: 'left',
         p:2,
         pr:3,
         pb:0
         }}>
        En Kuarzo Content Studio, nos dedicamos a crear contenido de vanguardia para nuestros clientes.
      </Typography> */}
{/*       
      <Box sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
        <LiveProductionWall videos={videos} />
      </Box> */}
    </Box>
  );
};

export default Home; 
